export function deduplicateItems(items) {
  var seen = {};
  var values = [];
  return items.reduce((acc, item) => {
    if (seen[item.id]) {
      return acc;
    }

    seen[item.id] = true;
    return [...acc, item];
  }, values);
}
export function sortItems(items) {
  return items.sort((a, b) => {
    return new Date(b.inserted_at).getTime() - new Date(a.inserted_at).getTime();
  });
}
//# sourceMappingURL=utils.js.map